<template>
  <div class="List">
    <van-nav-bar
      title="线索"
      fixed
      placeholder
      :z-index="10"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <van-search
      v-model="filter.name"
      show-action
      background="#fff"
      placeholder="请输入线索名称"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="list-box"
      >
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <CaseCard
            @click.native="onItemClick(item)"
            :item="item"
            class="item"
            @actionClick="onActionClick"
          >
          </CaseCard>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="bottom-btn">
      <div class="btns">
        <van-button round type="info" @click="$router.push('/list/create')"
          >新增线索</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "vant";
import { Icon } from "vant";
import { Tabbar, TabbarItem } from "vant";
import Api from "@/api/user";
import Vue from "vue";
Vue.use(Search, Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
import popupFormMixin from "@/mixins/popupFormMixin";

import { Toast, Dialog } from "vant";
export default {
  mixins: [popupFormMixin],
  props: {},
  components: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      checkedAll: false,
      refreshing: false,
      filter: {
        name: "",
      },
      pageNo: 1,
      pageSize: 10,
    };
  },
  computed: {},
  methods: {
    batchProcessing() {
      let checkedHomeNos = this.list
        .filter((item) => item.checked)
        .map((item) => item.homeNo);
      if (this.actionType == "批量改派") {
        this.changeClick({}, checkedHomeNos);
      } else {
        this.distributeClick({}, checkedHomeNos);
      }
    },
    onItemClick(item) {
      this.$router.push(`/detail/${item.id}`);
    },
    onChange(v) {
      this.list.forEach((element) => {
        element.checked = v;
      });
      this.checkedAll = v;
    },
    onActionClick(action, item) {
      if (action == "跟进") {
        this.$router.push(`/follow?bizId=${item.id}&name=${item.name}`);
      } else {
        Dialog.confirm({
          title: "提示",
          message: `确定将【${item.name}】转化为客户吗？`,
        })
          .then(async () => {
            await Api.clueTurnIntoCustomers(item.id);
            Toast.success("转化成功");
            this.onRefresh();
          })
          .catch((res) => {
            console.log("res :>> ", res);
          });
      }
    },
    handelTab() {
      this.checkedAll = false;
      const parameterUrl = this.$router.resolve({
        name: this.$route.name,
        query: {
          ...this.filter,
        },
      }).href;
      history.replaceState(null, null, parameterUrl);
      this.onRefresh();
    },
    onSearch() {
      this.pageNo = 1;
      this.list = [];
      this.onLoad();
    },
    async onLoad() {
      try {
        this.finished = false;
        this.loading = true;
        const { pageNo, pageSize, filter } = this;
        const params = {
          pageNo,
          pageSize,
          ...filter,
          name: this.filter.name,
        };

        var res = await Api.findPageISO(params);
        const { data } = res;
        const { list } = data;
        list.forEach((item) => {
          item.checked = false;
        });
        if (this.pageNo == 1) {
          this.list = list;
        } else {
          this.list = [...this.list, ...list];
        }
        this.finished = !data.isNextPage;
        this.pageNo++;
      } catch (error) {
        Toast.fail(error);
        this.list = [];
        this.finished = true;
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    onRefresh() {
      this.pageNo = 1;
      this.checkedAll = false;
      this.onLoad();
    },
  },
};
</script>

<style lang="less" scoped>
.List {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.van-tabs {
  /deep/ .van-tabs__line {
    background: #3c86ff !important;
    height: 2px !important;
    width: 4em !important;
  }
}

.list-box {
  padding: 10px 12px;
  .list-item {
    position: relative;
    .checkbox {
      position: absolute;
      right: 17px;
      top: 18px;
      z-index: 3;
      /deep/ .van-checkbox__icon .van-icon {
        border-width: 2px;
      }
    }
  }
  .item {
    margin-bottom: 15px;
  }
}
</style>
